// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"215":"433712d3","397":"2ab7e45f","453":"a413a31b","461":"b14eae41","495":"83c395f5","979":"322a62dd"}[chunkId] + ".chunk.js";
};